export enum OpgavenBedoemmesEfterEnum {
    HoejereErBedre = 1,
    LavereErBedre = 2,
    Valgmuligheder = 3,
    TaetPaaKendtVaerdi = 4
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/enums/OpgavenBedoemmesEfterEnum.ts